import { styles } from './ServiceIcon.css';
import Tick from '@jbhi-fi/lanyard-ui/components/Icons/Tick';
import React from 'react';

interface IconProps {
  imageUrl?: string;
  size?: number;
  selected?: boolean;
  isMobileExtra?: boolean;
}

export const ServiceIcon = ({ imageUrl, size, selected, isMobileExtra = false }: IconProps) => {
  return (
    <div className={styles.serviceIconWrap} style={{ width: size, height: size }}>
      {!!selected && isMobileExtra ? <Tick tickFill="#ffffff" className={styles.tick} /> : null}
      <img alt="Service offering icon" className={styles.icon} src={imageUrl} width={size} height={size} />
    </div>
  );
};
